import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import Badge from "components/bootstrap/Badge";
import { OverlayTrigger, Spinner, Icon } from "components/common";
import { useDetectionChainEventDefinitionSummary } from "security-app/hooks/useSecurityEventsAPI";
import { Row } from "common/components";
import DetectionChainRulesList from "security-app/components/DetectionChains/DetectionChainRulesList";
import DetectionChainRulesHeader from "security-app/components/DetectionChains/DetectionChainRulesHeader";
export function DetectionChainDetails({ chainRules }) {
  return /* @__PURE__ */ React.createElement(DetectionChainRulesList, { chainRules });
}
function DetectionChain({ eventId }) {
  var _a;
  const { t } = useTranslation("enterprise_security_events");
  const { detectionChain, loadingDetectionChain } = useDetectionChainEventDefinitionSummary(eventId);
  if (loadingDetectionChain) return /* @__PURE__ */ React.createElement(Spinner, { text: t("detection_chain.loading") });
  const detailsWithheld = !(detectionChain == null ? void 0 : detectionChain.title) && !((_a = detectionChain == null ? void 0 : detectionChain.rules) == null ? void 0 : _a.length);
  if (detailsWithheld) {
    return /* @__PURE__ */ React.createElement(Badge, { bsStyle: "info", "data-testid": "detection-chain-withheld" }, t("detection_chain.part_of_chain"));
  }
  return /* @__PURE__ */ React.createElement(
    OverlayTrigger,
    {
      trigger: "click",
      rootClose: true,
      placement: "right",
      overlay: /* @__PURE__ */ React.createElement(DetectionChainDetails, { chainRules: detectionChain.rules }),
      title: /* @__PURE__ */ React.createElement(DetectionChainRulesHeader, { chainName: detectionChain.id }),
      width: 800
    },
    /* @__PURE__ */ React.createElement(Row, { $gap: "xxs", $align: "center", "data-testid": "detection-chain-link" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "link" }, /* @__PURE__ */ React.createElement("strong", null, detectionChain.title)), /* @__PURE__ */ React.createElement(Icon, { name: "arrow_right", size: "sm" }))
  );
}
export default DetectionChain;
